import beverageGlass from "../../../../images/beverage.png";
export const beverageData = [
  {
    name: "Special Juice",
    image: beverageGlass,
    price: "40.00",
    description: "chicken,BBQ sauce,tomato",
  },

  {
    name: "Special Juice",
    image: beverageGlass,
    price: "130.00",
    description: "beef patty, BBQ sauce,",
  },
  {
    name: "Special Juice",
    price: "150.00",
    deletedprice: "200.50",
    description: "cheese,Naga",
  },
  {
    name: "Special Juice",
    image: beverageGlass,
    price: "15.00",
    deletedprice: ".200",
    description: "cheese,Naga",
  },
  {
    name: "Matha juice",
    image: beverageGlass,
    price: ".15",
    deletedprice: ".20",
    description: "cheese,Naga",
  },
];
